var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Celebration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11v15.63a15.87 15.87 0 0014 15.64V61h-8v4h20v-4h-8V42.26a16.14 16.14 0 009.88-5.12A15.47 15.47 0 0054 26.63V11H22zm28 14H26V15h24v10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Celebration.5640541d.svg";
export { SvgF1Celebration as ReactComponent };